import {Activity} from "@/types";

export class BaseActivityOccurrence {
  id?: string
  startDate?: string
  endDate?: string
}

export class ActivityOccurrence extends BaseActivityOccurrence {
  occupiedPlaces?: number
  slug?: string
  activity: Activity

  constructor() {
    super();
    this.activity = {}
  }
}